import type * as React from 'react';
import { get } from '@Domain/Api';
import contactRolesFetched, {
	type ContactRolesFetchedAction,
	type ContactRolesFetchedPayload,
} from '@Application/Beneficiaries/BeneficiaryContacts/ContactRoles/Actions/contactRolesFetched';
import contactRolesFetchFailed, {
	type ContactRolesFetchFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/ContactRoles/Actions/contactRolesFetchFailed';
import type FetchContactRoles from '@Application/Beneficiaries/BeneficiaryContacts/ContactRoles/Queries/FetchContactRoles';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = ContactRolesFetchedAction | ContactRolesFetchFailedAction;

export default (_query: FetchContactRoles) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<ContactRolesFetchedPayload>(
				`${parameters.api.host}/api/enums/contact-roles`,
			);

			const action = contactRolesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = contactRolesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
